import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast, Toast, ToastVariant } from '@hungryroot/components-toast';
import { StatusCode } from '@hungryroot/rest';
import {
  postUnskipOrder,
  type UnskipOrderData,
} from '@hungryroot/rest/api/unskip_order/post';
import { invalidatePastCurrentUpcomingOrders } from '../utils/invalidatePastCurrentUpcomingOrders';

export function useUnskipOrder() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (params: { data: UnskipOrderData }) => {
      const { data } = params;
      const res = await postUnskipOrder(data);
      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get_customer_dashboard'] });
      queryClient.invalidateQueries({ queryKey: ['Orders'] });
      invalidatePastCurrentUpcomingOrders(queryClient);
      toast(
        <Toast testid="toast-unskip" variant={ToastVariant.Neutral}>
          Woohoo! Your delivery is unskipped.
        </Toast>
      );
    },
  });
}
